<template>
  <div class="pv-trend-chart">
    <Chart
      ref="bizChart"
      id="pv-weekly-energy-chart"
      width="100%"
      height="100%"
      :option="chartOption"
    />
  </div>
</template>

<script>
import Chart from "@/components/echarts/Chart.vue";
import moment from "moment";
import {
  getWeeklyTrend,
  exportWeeklyTrendFile,
} from "@/network/photovoltaic";
import { downloadBlobFile } from "@/constant/export-file";

export default {
  name: "PvTrendChart",
  components: { Chart },
  data() {
    return {
      dates: [],
      generation: [],
      consumption: [],
      total: [],
      pollTimer: null,
    };
  },
  computed: {
    chartOption() {
      const n = Math.max(
        this.dates.length,
        this.generation.length,
        this.consumption.length,
        this.total.length,
        1
      );
      const safeDates =
        this.dates.length > 0
          ? this.dates
          : Array.from({ length: n }, (_, i) => String(i + 1));
      const pad = (arr) => {
        if (arr.length >= n) return arr.slice(0, n);
        const out = arr.slice();
        while (out.length < n) out.push(null);
        return out;
      };
      const gen = pad(this.generation);
      const con = pad(this.consumption);
      const tot = pad(this.total);
      return {
        tooltip: { trigger: "axis" },
        legend: {
          data: ["光伏", "市电", "总量"],
          textStyle: { color: "rgba(255,255,255,0.5)", fontSize: 10 },
          bottom: -2,
        },
        grid: { left: 30, right: 10, top: 5, bottom: 20 },
        xAxis: {
          type: "category",
          data: safeDates,
          axisLine: {
            lineStyle: { color: "rgba(255,255,255,0.08)" },
          },
          axisLabel: { color: "rgba(255,255,255,0.3)", fontSize: 9 },
        },
        yAxis: {
          type: "value",
          name: "kWh",
          nameTextStyle: { color: "rgba(255,255,255,0.3)", fontSize: 9 },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.04)",
              type: "dashed",
            },
          },
          axisLabel: { color: "rgba(255,255,255,0.3)", fontSize: 9 },
        },
        series: [
          {
            name: "光伏",
            type: "line",
            smooth: true,
            lineStyle: { width: 1.5, color: "#ffa500" },
            itemStyle: { color: "#ffa500" },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(255,165,0,0.25)" },
                  { offset: 1, color: "rgba(255,165,0,0)" },
                ],
              },
            },
            data: gen,
          },
          {
            name: "市电",
            type: "line",
            smooth: true,
            lineStyle: { width: 1.5, color: "#00d4ff" },
            itemStyle: { color: "#00d4ff" },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(0,212,255,0.25)" },
                  { offset: 1, color: "rgba(0,212,255,0)" },
                ],
              },
            },
            data: con,
          },
          {
            name: "总量",
            type: "line",
            smooth: true,
            lineStyle: { width: 1, color: "#00e676", type: "dashed" },
            itemStyle: { color: "#00e676" },
            data: tot,
          },
        ],
      };
    },
  },
  mounted() {
    this.fetchTrend();
    this.pollTimer = setInterval(() => this.fetchTrend(), 120000);
  },
  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  },
  methods: {
    fetchTrend() {
      getWeeklyTrend()
        .then((res) => {
          if (!res || res.code !== 0 || !res.data) return;
          const d = res.data;
          this.dates = Array.isArray(d.dates) ? d.dates : [];
          this.generation = Array.isArray(d.generation)
            ? d.generation.map(Number)
            : [];
          this.consumption = Array.isArray(d.consumption)
            ? d.consumption.map(Number)
            : [];
          this.total = Array.isArray(d.total)
            ? d.total.map(Number)
            : [];
        })
        .catch(() => {});
    },
    resizeChart() {
      this.$nextTick(() => {
        const ref = this.$refs.bizChart;
        if (ref && typeof ref.resize === "function") ref.resize();
      });
    },
    exportWeeklyTrend() {
      exportWeeklyTrendFile()
        .then((buf) => {
          if (buf instanceof ArrayBuffer && buf.byteLength > 0) {
            downloadBlobFile(buf, `能耗趋势七日_${moment().format("YYYYMMDD")}`);
            return;
          }
          if (this.$message) this.$message.warning("暂无导出内容");
          else window.alert("暂无导出内容");
        })
        .catch(() => {
          if (this.$message) this.$message.error("导出失败");
          else window.alert("导出失败");
        });
    },
  },
};
</script>
